export default "__VITE_ASSET__45766b3c__"